/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
export const PROPOSED_DISCOUNT_VALUE_PATTERN = /^(\d+|\d+\.\d+)$/;

export const isCompleteProposedDiscount = (discount: {
  kind?: string | null;
  value?: string | null;
  basis?: string | null;
}) =>
  Boolean(discount.kind) &&
  Boolean(discount.basis) &&
  Boolean(discount.value) &&
  PROPOSED_DISCOUNT_VALUE_PATTERN.test(discount.value ?? '');
